module.exports = __webpack_public_path__ + "img/icon_level.a3bd3826.svg";